import { LeftBar } from "../../components";
import Main from "./component.main";
import store from "./script.store";
const Screens = { LeftBar, Main, store };
export default Screens;
